import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    if (this.editable(event.target) || this.itemTargets.length === 0) return

    if (["j", "k"].includes(event.key.toLowerCase())) {
      event.preventDefault()
      this.focusItem(event.key.toLowerCase() === "j" ? 1 : -1)
    } else if (event.key === "Enter") {
      const item = this.activeItem()
      if (item) {
        event.preventDefault()
        item.querySelector("a")?.click()
      }
    } else if (event.key.toLowerCase() === "e") {
      const item = this.activeItem()
      const form = item?.querySelector("form[data-inbox-handle]")
      if (form) {
        event.preventDefault()
        form.requestSubmit()
      }
    }
  }

  focusItem(direction) {
    const current = this.itemTargets.indexOf(this.activeItem())
    const next = current < 0 ? (direction > 0 ? 0 : this.itemTargets.length - 1) : Math.max(0, Math.min(this.itemTargets.length - 1, current + direction))
    this.itemTargets[next].focus()
  }

  activeItem() {
    return document.activeElement?.closest("[data-inbox-target='item']")
  }

  editable(target) {
    return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) || target.isContentEditable
  }
}
